import * as THREE from "three";
import { useMemo } from "react";
import { ROOF_HEIGHT } from "../../lib/consts";
import { PRESET } from "../../lib/lighting-presets";
import { THICKNESS, buildUshape } from "./shared";

export default function Ceiling() {
	const geo = useMemo(() => {
		const s = buildUshape();
		return new THREE.ExtrudeGeometry(s, { depth: THICKNESS, bevelEnabled: false });
	}, []);
	const ceilingEmissive = PRESET.mezzanine.ceilingEmissive;

	return (
		<mesh position={[0, ROOF_HEIGHT, 0]} rotation={[Math.PI / 2, 0, 0]} frustumCulled={false} receiveShadow>
			<primitive object={geo} />
			<meshStandardMaterial color="#ff5100" roughness={0.7} emissive="#ff5100" emissiveIntensity={ceilingEmissive} />
		</mesh>
	);
}
